// ─────────────────────────────────────────────────────────────────────────────
// External References Selectors
// ─────────────────────────────────────────────────────────────────────────────
// NgRx selectors for the externalReferences store slice.
// ─────────────────────────────────────────────────────────────────────────────

import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ExternalReferencesState } from './external-references.reducers';

// ── Feature selector ─────────────────────────────────────────────────────────

export const selectExternalReferences = createFeatureSelector<ExternalReferencesState>('externalReferences');

// ── Basic selectors ──────────────────────────────────────────────────────────

export const selectExternalReferenceItems = createSelector(selectExternalReferences, (state) => state.references);
export const selectExternalReferenceMetadata = createSelector(selectExternalReferences, (state) => state.metadata);
export const selectExternalReferenceLoading = createSelector(selectExternalReferences, (state) => state.loading);
export const selectExternalReferenceKeyword = createSelector(selectExternalReferences, (state) => state.keyword);
export const selectExternalReferenceFilters = createSelector(selectExternalReferences, (state) => state.filters);
